// extracted by mini-css-extract-plugin
export default {"container":"splash_container__ncFjY"};